import React from 'react';

type DealerNameProps = {
  name: string | undefined;
};
// Making ":plus" italic
const DealerName: React.FC<DealerNameProps> = ({ name }) => (
  <>
    {name?.split(' ').map((component, index) => (
      /* eslint-disable-next-line react/no-array-index-key */
      <span key={index}>{component === ':plus' ? <i>{component}</i> : component} </span>
    ))}
  </>
);

export default DealerName;
